import React from 'react';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(),
    top: theme.spacing(),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;
  return (
    <div style={{ borderBottom: '1px solid #adadad' }}>
      <MuiDialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
            style={{ outline: 'none' }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    </div>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(),
  },
}))(MuiDialogActions);

class Dialog extends React.Component {
  render() {
    const { title, content, actions, open, onClose, props } = this.props;

    return (
      <MuiDialog
        open={open}
        onClose={onClose}
        aria-labelledby={`${title}-dialog-title`}
        {...props}
      >
        <DialogTitle onClose={onClose}>{title}</DialogTitle>

        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {actions
            ? actions.map(action => (
                <Button
                  disabled={action.disabled}
                  onClick={action.onClick}
                  color="primary"
                  key={action.label}
                >
                  {action.label}
                </Button>
              ))
            : null}
        </DialogActions>
      </MuiDialog>
    );
  }
}

export default Dialog;
